<div id="action-required" class="container">
    
    <div *ngFor="let item of data">
        
        <!-- {{ item.lender }}
        {{ item.requiredSubmittedDate }}
        {{ item.lastSubmittedDate }}
        {{ item.dusGatewayDealAndID }} -->

        <div>
            <div>
                <div class = "actionRequiredHeader">
                    <div class="actionRequiredPropertyHeader" title = "{{item.propertyName}}"> {{item.propertyName}}</div>
                    <div>
                        <button class="button_upload_file" fmButton type="button" [primary]="true" icon="fmi fmi-upload"
                            label="Upload Files"
                            (click)="showUploadFilesDialog(true, item.propertyName, item.dusGatewayDealAndID, item.collateralReferenceNumber, item.acquisitionDealId, item.propertyMasterNumber, item.transType, item.ssn, item.propId, item.cmmtNo)">
                        </button>
                    </div>
                </div>       
                <fm-dataList>

                    <ng-template fmTemplate="subheader">

                        <button class="button_no" *ngIf="!item.appr || item.appr == 'N'">Missing APPR</button>
                        <button class="button_yes" *ngIf="item.appr == 'Y'">APPR</button>
                        <button class="button_no_applicable" *ngIf="item.appr == 'N/A'">APPR</button>

                        <button class="button_no" *ngIf="!item.esa || item.esa == 'N'">Missing ESA</button>
                        <button class="button_yes" *ngIf="item.esa == 'Y'">ESA</button>
                        <button class="button_no_applicable" *ngIf="item.esa == 'N/A'">ESA</button>

                        <button class="button_no" *ngIf="!item.pca || item.pca == 'N'">Missing PCA</button>
                        <button class="button_yes" *ngIf="item.pca == 'Y'">PCA</button>
                        <button class="button_no_applicable" *ngIf="item.pca == 'N/A'">PCA</button>

                        <button class="button_no" *ngIf="!item.sra || item.sra == 'N'">Missing SRA</button>
                        <button class="button_yes" *ngIf="item.sra == 'Y'">SRA</button>
                        <button class="button_no_applicable" *ngIf="item.sra == 'N/A'">SRA</button>

                        <button class="button_no" *ngIf="!item.zon || item.zon == 'N'">Missing ZON</button>
                        <button class="button_yes" *ngIf="item.zon == 'Y'">ZON</button>
                        <button class="button_no_applicable" *ngIf="item.zon == 'N/A'">ZON</button>

                  
          

                        <!-- Display the required submitted date based on the date -->
                        <div class="my_datalist_container">
                            <div class="my_datalist_label">REQUIRED SUBMISSION DATE</div>
                            <div class="my_datalist_text" *ngIf="item.pastDue == true">{{item.requiredSubmittedDate}}
                            </div>
                            <div class="my_datalist_text_highlight" *ngIf="item.pastDue == false">
                                {{item.requiredSubmittedDate}}</div>
                        </div>

                        <div class="my_datalist_container">
                            <div class="my_datalist_label">LAST SUBMITTED DATE</div>
                            <div class="my_datalist_text">{{item.lastSubmittedDate}}</div>
                        </div>

                        <div class="my_datalist_container">
                            <div class="my_datalist_label">DUS GATEWAY DEAL AND ID</div>
                            <div class="my_datalist_text">{{item.dusGatewayDealAndID}}</div>
                        </div>

                        <div class="my_datalist_container">
                            <div class="my_datalist_label">(EST.) ACQUISITION DATE</div>
                            <div class="my_datalist_text">{{item.estimatedAcquisitionDate}}</div>
                        </div>

                        <div class="my_datalist_container_no_line">
                            <div class="my_datalist_label">COLLATERAL REFERENCE NUMBER</div>
                            <div class="my_datalist_text">{{item.collateralReferenceNumber}}</div>
                        </div>
                    </ng-template>

                    <ng-template fmTemplate="rowText" let-rowItem>
                        <div style="color: black; float: right;">{{ rowItem.text }}</div>
                    </ng-template>

                </fm-dataList>
            </div>
        </div>
    </div>
</div>
<app-file-upload *ngIf="showUploadFiles" (showUploadFiles)="getUploadFilesDialogStatus($event)"></app-file-upload>
